import { memo, useState } from 'react';
import { sortBy } from 'lodash';
import { useQuery } from '@tanstack/react-query';
import { fetchUsers } from './Users.services.ts';

import type { UserFormValues, UserType } from './Users.types.ts';

import Users from './Users';
import { useService } from './Users.hooks.ts';

export const UsersContainer = () => {
  const { crateMutation, updateMutation } = useService();

  const [selectedUserKeys, setSelectedUserKeys] = useState<React.Key[]>([]);
  const [openUserDrawer, setOpenUserDrawer] = useState<boolean>(false);
  const [userId, setUserId] = useState<number | string | undefined | null>(null);
  const { data, isLoading } = useQuery({
    queryKey: ['users'],
    queryFn: fetchUsers,
    retry: false,
  });

  const users = sortBy(
    data?.map((user: UserType) => ({ ...user, isSelected: false })),
    'order',
  );

  const handleOpenUserDrawer = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    id: number | string | undefined | null,
  ) => {
    if (event) event.preventDefault();
    if (id === undefined) return;

    setUserId(id);
    setOpenUserDrawer(true);
  };

  const handleCloseUserDrawer = () => {
    setUserId(null);
    setOpenUserDrawer(false);
  };

  const handleSubmitUser = (values: UserFormValues) => {
    const data = values.roles?.map((role: number) => Number(role));

    if (values?.id) {
      updateMutation.mutate({ data, userId: values.id });
      handleCloseUserDrawer();
      return;
    }
    const params = {
      entraId: values?.user[0]?.value,
      displayName: values?.user[0]?.label,
      email: values?.email,
      roles: data,
    };
    crateMutation.mutate({ data: params });
    handleCloseUserDrawer();
  };

  return (
    <Users
      users={users}
      isLoading={isLoading}
      openUserDrawer={openUserDrawer}
      onOpenUserDrawer={handleOpenUserDrawer}
      onCloseUserDrawer={handleCloseUserDrawer}
      onSubmitUser={handleSubmitUser}
      selectedUserKeys={selectedUserKeys}
      setSelectedUserKeys={setSelectedUserKeys}
      userId={userId}
    />
  );
};

export default memo(UsersContainer);
